(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-llp-section]').forEach((section) => {
      if (section.dataset.llpInitialised === 'true') return;
      section.dataset.llpInitialised = 'true';

      const revealItems = section.querySelectorAll('[data-llp-reveal]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (section.dataset.animate !== 'true' || reduceMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      } else {
        section.classList.add('llp-motion-ready');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14 });
        revealItems.forEach((item) => observer.observe(item));
      }

      section.querySelectorAll('[data-llp-back-to-product]').forEach((button) => {
        button.addEventListener('click', () => {
          const product = document.querySelector('.product-info, [data-product-info], main-product');
          if (product) {
            product.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          }
        });
      });
    });
  };

  if (!window.LinksLeatherProductSections) {
    window.LinksLeatherProductSections = { init };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  } else {
    window.LinksLeatherProductSections.init(document);
  }
})();